import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAccount: null,
  members: [],
  inviteUsers: []
};

const accountSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setMembersAccount: (state, action) => {
      state.members = action.payload || [];
    },
    setInviteUsers: (state, action) => {
      state.inviteUsers = action.payload;
    },
    removeMemberUser: (state, action) => {
      state.members = state.members.filter(member => member.userId._id !== action.payload);
    },
    removeInvite: (state, action) => {
      state.inviteUsers = state.inviteUsers.filter(user => user.email !== action.payload);
    },
    updateInviteUserStatus: (state, action) => {
      const { email, status } = action.payload;
      state.inviteUsers = state.inviteUsers.map((user) =>
        user.email === email ? { ...user, status } : user
      );
    },
    clearAccount: () => initialState
  },
});

export const { setSelectedAccount, setMembersAccount, setInviteUsers, removeMemberUser, removeInvite, updateInviteUserStatus, clearAccount } = accountSlice.actions;
export default accountSlice.reducer;